<template>
    <div id="main_inviting_entrepreneurs">
        <div class="filters_entrepreneurs_container">
            <div class="filters_container">
                <div class="display_filter">
                    <p class="title">תצוגת יזמים לפי</p>
                    <div class="box_switch">
                        <div :class="{ selected: filters.display === 'recommended'}" @click="filters.display = 'recommended'" class="a">מומלצים למכרז שלך</div>
                        <div :class="{ selected: filters.display === 'all'}" @click="filters.display = 'all'" class="b">כל היזמים הרשומים</div>
                    </div>
                </div>
                <div class="search_filter">
                    <input type="text" v-model="filters.q" placeholder="חיפוש לפי שם היזם / חברה">
                    <div class="icon search_icon"></div>
                </div>
            </div>
            <div class="entrepreneurs_container" ref="entrepreneursContainer">
                <div v-show="!entrepreneurs.length > 0 && !is_loading" class="no_res">
                    <div class="text_icon_container">
                        <div class="icon search_big_icon"></div>
                        <p>לא מצאנו יזמים בחיפוש שהגדרת</p>
                        <div class="btn_b text_s" @click="filters.q = '';">איפוס</div>
                    </div>
                    <div class="tip">
                        <p>טיפ: ניתן להזין יזמים שעדיין לא רשומים למערכת</p>
                        <div class="icon corner_left_down_icon"></div>
                    </div>
                </div>
                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th>שם היזם / חברה</th>
                            <th>סיווג קבלני</th>
                            <th>
                                <div class="icon dunsloo_icon"></div>
                            </th>
                            <th>
                                <div class="icon bdi_logo"></div>
                            </th>
                            <th>
                                <div class="icon madad-logo"></div>
                            </th>
                            <th>
                                <div class="text_icon">
                                    <span>פרויקטים</span>
                                    <div class="icon help_icon" :title="get_word('invite_project_info', true)"></div>
                                </div>
                            </th>
                            <th class="center">
                                <span>אזורי פעילות</span>
                            </th>
                            <th>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="!is_loading">
                        <tr v-for="entrepreneure in entrepreneurs" :key="entrepreneure.id" :class="{active: entrepreneure.active}">
                            <td class="logo_name">
                                <div class="text_icon_container" @click="this.$bus.$emit('open_yazamdata', entrepreneure)">
                                    <div class="icon_container">
                                        <div class="icon" :style="bg(entrepreneure.data.company_logo)"></div>
                                    </div>
                                    <p class="name" v-if="entrepreneure.data.company_name" v-text="entrepreneure.data.company_name"></p>
                                </div>
                            </td>
                            <td class="classification_type">
                                <div class="con">
                                    <span v-if="entrepreneure.data.classification_type_text" v-text="entrepreneure.data.classification_type_text"></span>
                                </div>
                            </td>
                            <td class="file_container">
                                <div class="icon_text_container">
                                    <div class="icon" :class="{'file_attachment_icon': entrepreneure.data.bd_rating_link, 'no_file_to_show_icon': !entrepreneure.data.bd_rating_link}"></div>
                                    <a target="_blank" v-if="entrepreneure.data.bd_rating_link" :href="entrepreneure.data.bd_rating_link" class="text">לצפייה</a>
                                </div>
                            </td>
                            <td class="file_container">
                                <div class="icon_text_container">
                                    <div class="icon" :class="{'file_attachment_icon': entrepreneure.data.bdi_rating_link, 'no_file_to_show_icon': !entrepreneure.data.bdi_rating_link}"></div>
                                    <a target="_blank" v-if="entrepreneure.data.bdi_rating_link" :href="entrepreneure.data.bdi_rating_link" class="text">לצפייה</a>
                                </div>
                            </td>
                            <td class="file_container">
                                <div class="icon_text_container">
                                    <div class="icon" :class="{'file_attachment_icon': entrepreneure.data.urban_renewal_rating_link, 'no_file_to_show_icon': !entrepreneure.data.urban_renewal_rating_link}"></div>
                                    <a target="_blank" v-if="entrepreneure.data.urban_renewal_rating_link" :href="entrepreneure.data.urban_renewal_rating_link" class="text">לצפייה</a>
                                </div>
                            </td>
                            <td class="proj_num">
                                <span v-text="(entrepreneure.ttl_projects)"></span>
                            </td>
                            <td>
                                <div class="activity_areas">
                                    <template v-if="entrepreneure.data.activity_areas && entrepreneure.data.activity_areas.length > 0">
                                    <span v-for="(activity_area, i) in entrepreneure.data.activity_areas" :key="i"> {{ activity_area.name }},</span>
                                    </template>
                                </div>
                            </td>
                            <td class="send_invitation">
                                <div  class="btn_b" :class="entrepreneure.active ? 'cencel_invitation_container' : 'text_s'" @click="(!entrepreneure.active ? invaite_user(entrepreneure) : uninvaite_user(entrepreneure)) " >
                                    <span >שליחת הזמנה להתמודדות</span>
                                    <div class="cencel_invitation" :class="{active: entrepreneure.active}">
                                        <span>נשלחה הזמנה</span>
                                        <div class="btn_b text_s" >ביטול</div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <div class="loader" v-else></div>
                </table>
            </div>
        </div>
        <form class="add_entrepreneure" @submit.prevent="sendInvite">
            <div class="text">
                <!-- <p>יש לך יזם ספציפי בראש אבל הוא לא ברשימה?</p>
                <p>ממלאים את הפרטים ואנחנו כבר ניצור איתו קשר</p> -->
                <p>ברצונך להעביר את המכרז ליזם ספציפי, אך הוא עדיין לא מופיע באתר? באפשרותך לכתוב כאן את פרטיו ואנו נדאג ליצור איתו קשר</p>
            </div>
            <input type="email" required v-model="email" placeholder="אימייל">
            <input type="phone" required v-model="phone" placeholder="טלפון">
            <input type="text" required v-model="en_name" placeholder="שם היזם">
            <input type="submit" value="שליחה" class="btn_b text_s"/>
        </form>
    </div>
  
</template>

<script>
export default {
     props:{
        token: {
        type: String,
        required: true
        },
        form: {
            type: Object,
            required: true
        },
        more_filters: {
            type: Object,
            required: false
        },

    },
    data() {
        return {
            filters: {
                search: '',
                q: '',
                token: this.token,
                display: 'all',
            },
            page: 0,
            limit: 20,

            num_items: null,
            en_name:'',
            phone: null,
            email: '',
            is_loading: false,
            loaded: false,
            lastScrollPosition: 0,
            entrepreneurs: []
        }
    },
    watch: {
      filters: {
          handler:  function() {
            this.page = 0;
            this.loadData();
          },
          deep: true
      },
      more_filters: {
          handler: function() {
            this.page = 0;
            this.loadData();
          },
          deep: true
      }
    },
    methods:{
        handleScroll() {
            const container = this.$refs.entrepreneursContainer;
            const scrollPosition = container.scrollTop + container.clientHeight;
            const containerHeight = container.scrollHeight;
            
            // Save last scroll position
            this.lastScrollPosition = container.scrollTop;
            
            if (containerHeight - scrollPosition <= 1000) {
                if (!this.is_loading && this.entrepreneurs.length < this.num_items) {
                    this.page++;
                    this.loadData(true); // Pass true to indicate pagination
                }
            }
        },
        loadData(isPagination = false) {
            this.is_loading = true;

            // Only save scroll position if this is pagination
            const container = this.$refs.entrepreneursContainer;
            const scrollTop = isPagination ? this.lastScrollPosition : 0;

            const filter_items = (items) => {
                return items.map((item) => {
                    if (item.data.activity_areas) {
                        item.data.activity_areas = item.data.activity_areas.sort((a, b) => {
                            const city = this.form.first_city;
                            if (a.name === city && b.name !== city) {
                                return -1;
                            } else if (a.name !== city && b.name === city) {
                                return 1;
                            } else {
                                return 0;
                            }
                        });
                    }
                    return item;
                });
            };

            this.api({action: 'entreprenuer/results', data: {...this.filters, limit: this.limit, page: this.page, more_filters: this.more_filters}}, (data) => {
                if (this.page === 0) {
                    this.entrepreneurs = filter_items(data.data.items);
                } else {
                    this.entrepreneurs.push(...filter_items(data.data.items));
                }

                if (data.data?.num) {
                    this.num_items = data.data.num;
                }

                this.is_loading = false;
                this.$emit('invitingEntrepreneursData', this.entrepreneurs.filter(item => item?.active));

                // Restore scroll position after data is loaded
                this.$nextTick(() => {
                    if (isPagination) {
                        container.scrollTop = scrollTop;
                    }
                });
            });
        },
        invaite_user(item) {
            this.api({action: 'projects/invaite_user' ,data: {id:item.id ,token:this.token}}, () => {
                item.active = true;
                this.$emit('invitingEntrepreneursData', this.entrepreneurs.filter(item => item?.active))
            });
        },
        uninvaite_user(item) {
            this.api({action: 'projects/uninvaite_user' ,data: {id:item.id ,token:this.token}}, () => {
                item.active = false;
                this.$emit('removeIvit', item?.id)
            });
        },
        sendInvite() {
            this.api({action: 'projects/send_invite' ,data: {name:this.en_name, email: this.email, phone: this.phone ,token:this.token}}, () => {
                this.en_name = '';
                this.email = '';
                this.phone = null;
                this.toast('ההזמנה נשלחה בהצלחה');
            });
        },
    },
    mounted() {
        this.$refs.entrepreneursContainer.addEventListener('scroll', this.handleScroll);

        this.loadData();

        this.$nextTick(() => {
            this.loaded = true;
        }); 
    },
    unmounted() {
        try {
            this.$refs.entrepreneursContainer.removeEventListener('scroll', this.handleScroll);
        } catch (e) {
            console.error(e);
        }
    },
}
</script>

<style lang="scss">
#main_inviting_entrepreneurs { display: flex; flex-direction: column; gap: var(--gap_mid);
    .filters_entrepreneurs_container { display: flex; flex-direction: column; gap: var(--gap_mid); 
        .filters_container { display: flex; justify-content: space-between;
            .display_filter { display: flex; align-items: center; gap: var(--gap);  }
            
        }
        .entrepreneurs_container { position: relative; height: 676px; overflow-y: auto; overflow-x: hidden; border-radius: var(--radius); border-style: hidden;box-shadow: 0 0 0 1px var(--pageBG); 
            
            table { border-collapse: collapse; border-spacing: 30px;
                thead { z-index: 1; background: var(--gray);position: sticky; 
	top: 0px; }
                // tbody { display: block; max-height: 300px; overflow-y: auto;} 
                tr {
                    &.active, &:hover {
                        .send_invitation { opacity: 1; }
                    }
                    &:not(:first-child) { border-top: 1px solid var(--pageBG);
                        &:hover {
                            &, & + * { border-top: 1px solid var(--light_blue); 
                                
                            }
                        }
                    }
                    .text_icon { display: flex; align-items: center; gap: 7px;
                        .icon { fill: var(--light_blue);}
                    }
                    // &:hover {
                    //     &, + { border-bottom: 1px solid #333; }
                    // }
                    
                    th { white-space: nowrap; padding-left: 32px;
                        &:first-child { padding-inline: var(--gap_xbig) 0;}
                        // &:last-child { padding-inline: 0 var(--gap_xbig);}
                        // & > * {display: inline-block !important;}
                        &.center { text-align: center;}
                        .dunsloo_icon { width: 46px; height: 56px; }
                        
                    }
                    td {padding-block: var(--gap);
                        &:first-child { padding-inline: var(--gap_big) 0;}
                        &.send_invitation { opacity: 0;  padding-left: var(--gap); }
                        &.proj_num {     
                            span {  margin-right: 26px;}
                        }
                        &.classification_type {
                            .con { width: 100%; display: flex; justify-content: center; 
                                span { padding: 2px 20px; background: #F5F9FA; border: 1px solid #E7F0F3; border-radius: 30px; }
                            }
                        }

                        &.logo_name { 
                            .text_icon_container { display: flex; align-items: center; gap: var(--gap_mid);
                            cursor: pointer;
                                .icon_container { padding: var(--padding_small); display: flex; justify-content: center; align-items: center; min-width: 120px; height: 100px; border-radius: var(--radius_s);
                                    .icon { width: 100%; height: 100%; background-size: contain;background-repeat: no-repeat;background-position: center; }
                                
                                }
                            }
                        }
                        &.file_container { min-width: 75px;
                            &:hover {
                                .icon_text_container {
                                    .icon { display: none;}
                                    .text { display: block;}
                                }
                            }
                            .icon_text_container { 
                                .text { cursor: pointer; display: none; color: var(--dark_blue); font-weight: bold; text-decoration: underline;}
                            }
                        }
                        // &:last-child { padding-inline: 0 var(--gap_big);}
                        .activity_areas {display: flex;flex-wrap: wrap;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;max-width: 230px;
                            span {margin-left: 5px;}
                        }
                        >.btn_b { flex-direction: column;/*padding-block: 7px;*/ gap: 0px !important; width: fit-content; margin: 0 auto; transition: all ease 0.3s;
                            > span { 
                                // transform: translateY(20%);
                                 opacity: 1;  max-height: 999px;white-space: nowrap;}
                        }
                        .cencel_invitation_container {align-items: normal; display: flex; gap: 0; border: none; width: fit-content; background: var(--light); border-radius: var();
                            > span { transform: translateY(-100%); opacity: 0;  max-height: 0;}
                            
                        }
                        .cencel_invitation { padding-block: 10px; max-height: 0; display: none; max-width: 0px; align-items: center; gap: var(--gap_xmid);
                            &.active { max-width: 9999px; max-height: 999px; display: flex;
                                > span { opacity: 1; transform: translateX(0%);white-space: nowrap;}
                                .btn_b { opacity: 1; transform: translateX(0%);}
                            }
                            > span { transition: all ease 0.2s; opacity: 0; transform: translateX(100%); color: #3F3BCC; font-size: var(--h5); font-weight: normal;}
                            .btn_b { width: fit-content; opacity: 0; transition: all ease 0.2s; transform: translateX(-100%);}
                        }
                    }
                }
            }
        }
    }
    .add_entrepreneure { padding: 24px 32px; border-radius: var(--radius); border: 1px solid var(--pageBG); display: flex; gap: var(--gap); align-items: center; justify-content: space-between;
        .text { display: flex; flex-direction: column; }
        input { width: 30%; height: 40px; font-size: var(--h5); border-radius: 12px; }
        .btn_b { width: fit-content;}
    }


}
</style>